import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
} from "@angular/core";

@Component({
  selector: "app-upgrade-prompt",
  templateUrl: "./upgrade-prompt.component.html",
  styleUrls: ["./upgrade-prompt.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class UpgradePromptComponent {
  @Input() public upgradeUrl: string;

  @Output() public primaryClick = new EventEmitter<void>();
  @Output() public dismiss = new EventEmitter<void>();
}
